import { lang, commonLang, _system, isSystem, getCurrentLang } from '@umu/ukit-lang';
import React, { Fragment, useEffect, useState } from 'react';
import API from '@umu/umu-api';
import { $window, getQueryString } from '@umu/umu-dom';
import * as ua from '@umu/umu-ua';
import { fetch } from '@umu/umu-fetch';

import { pinUrl, buildTenantIdQuery, getFactFromUrl } from '../../../@utils/umuUtil';
import './menuItem.scss';

interface IMenuItemProps {
    text: string;
    url: string;
    className?: string;
}
interface IOfficialUserInfo {
    official_announcement_status: OFFICIAL_ANNOUNCEMENT_STATUS;
}
enum OFFICIAL_ANNOUNCEMENT_STATUS {
    HIDE,
    SHOW,
    SHOW_MSG,
}
function LinkMenuItem(props: IMenuItemProps) {
    return (
        <div className={`link-menu-item ${props.className || ''}`}>
            <a href={props.url}>{props.text}</a>
        </div>
    );
}

export function Split() {
    return <span className="split-menu-item" />;
}

export function Login() {
    let fromUrl;
    // 无权限页强制登录后跳转from_url
    if (/^\/access-denied\//.test(window.location.pathname)) {
        fromUrl = getQueryString('from_url');
    }
    if (!fromUrl) {
        fromUrl = $window.location.href;
    }

    return <LinkMenuItem text={lang('登录')} url={`/globaluser/loginpage?from_url=${encodeURIComponent(fromUrl)}`} />;
}

export function Register() {
    return (
        <LinkMenuItem
            text={lang('注册')}
            url={`/globaluser/registerpage?from_url=${encodeURIComponent($window.location.href)}`}
        />
    );
}

export function Event() {
    return <LinkMenuItem text={lang('课程互动')} url={`/index/event`} />;
}

export function Course() {
    return <LinkMenuItem text={lang('微课制作')} url={`/index/course`} />;
}

export function Platform() {
    return <LinkMenuItem text={lang('企业学习平台')} url={`/product/enterprise`} />;
}
export function AiAudioSlides() {
    let component;
    component = <></>;
    return component;
}
export function LearningDesign() {
    return <LinkMenuItem text={lang('教学工具')} url={`/product/learning-design`} />;
}
export function ProductExercise() {
    return <LinkMenuItem text={lang('AI 作业')} url={`/product/exercise`} />;
}
export function ProductLive() {
    return <LinkMenuItem text={lang('互动直播')} url={`/product/live`} />;
}
export function ProductEvent() {
    let component;
    component = <></>;
    return component;
}
export function PlanPricing() {
    let component;
    component = <LinkMenuItem text={lang('订阅')} url={`/plan/pricing`} />;
    return component;
}
export function Education() {
    let component;
    component = <></>;
    return component;
}
export function LearnTask() {
    return <LinkMenuItem text={lang('学习任务')} url={'/profile/assignment'} />;
}

export function ParticipatedCourse() {
    return <LinkMenuItem text={lang('学习历史')} url={'/profile/#/participated'} />;
}

export function Website() {
    return <LinkMenuItem text={lang('UMU官网')} url={'/home'} />;
}

export function OFficialAnnouncement() {
    const [announcementStatus, setAnnouncementStatus] = useState<OFFICIAL_ANNOUNCEMENT_STATUS>(OFFICIAL_ANNOUNCEMENT_STATUS.HIDE);
    const onInit = () => {
        fetch.get('/api/profile/userinfo').then((res: {data: {teacherInfo: IOfficialUserInfo}}) => {
            const teacherInfo = res.data.teacherInfo || {};
            if (teacherInfo && teacherInfo.official_announcement_status) {
                setAnnouncementStatus(Number(teacherInfo.official_announcement_status))
            }
        });
    }
    useEffect(() => {
        onInit()
    },[])
    const isShow = announcementStatus !== OFFICIAL_ANNOUNCEMENT_STATUS.HIDE;
    const cls = announcementStatus === OFFICIAL_ANNOUNCEMENT_STATUS.SHOW_MSG ? 'announcements-btn-circle-msg' : ''
    return isShow ? <LinkMenuItem text={lang('官方公告')} url={'/announcements/index'} className={cls}/> : <></>;
}
export function Class() {
    return <LinkMenuItem text={lang('班级')} url={'/class/list'} />;
}

export function Faq(){
    if(!isSystem('JP')){
        return null;
    }
    const lang = getCurrentLang();
    let text = lang === 'jp' ? 'よくある質問' : 'FAQ';
    return <LinkMenuItem text={text} url={'https://tayori.com/faq/e789bde6e91c09073e63704a4be1872ac2b27902/'} />;
}

export function Academy(){
    if(!isSystem('JP')){
        return null;
    }
    const lang = getCurrentLang();
    let text = lang === 'jp' || lang === 'en' ? 'UMU Academy' : 'UMU 小课堂';
    return <LinkMenuItem text={text} url={'https://m.umu.co/main?eid=umu_academy#/index&parentCategoryId=-1'} />;
}

export function InputPin() {
    return <LinkMenuItem text={lang('输入访问码')} url={pinUrl} />;
}

export function Index() {
    return <LinkMenuItem text={lang('首页')} url={'/'} />;
}

export function Collections() {
    return <LinkMenuItem text={lang('我的收藏')} url={`/favorite/list/favorite`} />;
}

export function QuestionCollections() {
    return <LinkMenuItem text={commonLang('考题本')} url={`/favorite/list/question`} />;
}
/**
 * @desc 官网-uShow介绍页面
 */
export function UShowIntroducePanel() {
    return <LinkMenuItem text={lang('uShow')} url={'/product/u-show'} />;
}
/**
 * @desc 官网-测评介绍页面
 */
export function AssessmentIntroducePanel() {
    return <LinkMenuItem text={lang('测评')} url={'/product/assessment'} />;
}
/**
 * @desc 官网-学习圈介绍页面
 */
export function LearningCircleIntroducePanel() {
    return <LinkMenuItem text={lang('学习圈')} url={'/product/learning-circle'} />;
}
/**
 * @desc 官网-资源和动态介绍页面
 */
export function ResourcesAndDynamicsIntroducePanel() {
    let url = 'https://blog.umu.com';
    if (_system('cn')) {
        url = 'https://blog.umu.cn';
    }
    if (_system('jp')) {
        url = 'https://umujapan.co.jp/category/column/';
    }
    if (_system('em')) {
        url = 'https://blog.umu.io';
    }

    return isSystem('CN') || isSystem('JP') ? <Fragment><LinkMenuItem text={lang('资源和动态')} url={url} /><Split/></Fragment> : null;
}
export function Logout() {
    const onClick = () => {
        fetch.get(API.Path.USER_LOGOUT.url).then(() => {
            // 无权限页退出登录时，需要跳转到from_url中的链接，方便后端刷新当前显示状态
            if (/^\/access-denied\//.test(window.location.pathname)) {
                const fromUrl = getQueryString('from_url');
                if (fromUrl) {
                    window.location.href = decodeURIComponent(fromUrl);
                }
            }

            window.location.reload();
        });
    };

    if (ua.isWxChat) {
        const url = $window.location.href;
        const query = buildTenantIdQuery(url);
        const fromUrl = getFactFromUrl();
        const switchAccountUrl = `/globaluser/loginpage?${query}from_url=${encodeURIComponent(fromUrl)}#/skip_profile`;
        return (
            <div className="link-menu-item">
                <a href={switchAccountUrl}>{lang('切换账号')}</a>
            </div>
        );
    }
    return (
        <div onClick={onClick} className="link-menu-item">
            <a href="javascript:;">{lang('退出登录')}</a>
        </div>
    );
}

export function ContactUs() {
    let component;
    component = (
        <div className="link-menu-item contact-us-item">
            <a href="mailto:support@umu.co" className="mail">
                <span className="mail">support@umu.co</span>
            </a>
        </div>
    );
    return component;
}
